import React from 'react';
import './DeleteAppDraftDrawer.css';

function DeleteAppDraftDrawer({ onClose, onConfirm }) {
  return (
    <div className="appdraft-delete-overlay" onClick={onClose}>
      <div
        className="appdraft-delete-popup"
        onClick={(e) => e.stopPropagation()}
      >
        <h3>Delete App Draft?</h3>
        <p>This draft app will be removed permanently. You cannot undo this.</p>

        <div className="appdraft-delete-actions">
          <button className="appdraft-cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="appdraft-confirm-btn" onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteAppDraftDrawer;
